import { AlignValue, VerticalAlignValue, OptionsLayoutValue } from 'highcharts'

export const chartConfig = (displayPie: boolean, newHome?: boolean) => {
  const height = '400px'
  return {
    pieCSS: { width: '100%', height },
    chartCSS: { width: displayPie ? '60%' : '100%', height },
    css: {
      overflow: 'hidden',
      width: '100%',
      height,
      '> section': !newHome ? { width: '40%' } : '',
    },
    AreaSPLineOptions: {
      chart: {
        type: 'line',
        width: null,
        height: null,
        responsive: true,
      },
    },
    pieOptions: {
      chart: {
        type: 'pie',
        width: null,
        height: null,
        responsive: true,
      },
      plotOptions: {
        pie: {
          size: height.replace('px', ''),
        },
      },
      legend: {
        align: 'center' as AlignValue,
        verticalAlign: 'bottom' as VerticalAlignValue,
        layout: 'horizontal' as OptionsLayoutValue,
      },
    },
  }
}
